// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1PtoW","title":"Header_title__3fCcf","side":"Header_side__2R5Fc"};